import { Box, Divider, Skeleton, Stack, useTheme } from '@mui/material'
import { useMemo } from 'react'

import { getAgentChatSettings } from '~/features/agents/utils'
import { EPreChatFormKeys } from '~/features/preChatForms/models'
import { store } from '~/store'
import rem from '~/utils/ui'

function ChatDialogLoadingSkeleton() {
  const theme = useTheme()
  const chatSettings = store((state) => state.chatbot.agent.chatSettings)
  const form = getAgentChatSettings(chatSettings)?.form

  const showPreChatSkeleton = useMemo(() => {
    const fields = form?.[EPreChatFormKeys.fields] ?? []
    return fields.length > 0
  }, [form])

  return (
    <Stack
      sx={{
        width: '100%',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      <Stack gap={2} sx={{ padding: rem(16), flex: 1, minHeight: 0 }}>
        <Stack direction="row" gap={1.5} alignItems="flex-start">
          <Skeleton
            animation="wave"
            height={rem(36)}
            variant="circular"
            width={rem(36)}
          />
          <Stack flex={1} gap={0.75} sx={{ maxWidth: '85%' }}>
            <Skeleton
              animation="wave"
              height={rem(14)}
              sx={{ borderRadius: rem(8) }}
              variant="rounded"
              width="92%"
            />
            <Skeleton
              animation="wave"
              height={rem(14)}
              sx={{ borderRadius: rem(8) }}
              variant="rounded"
              width="78%"
            />
            <Skeleton
              animation="wave"
              height={rem(14)}
              sx={{ borderRadius: rem(8) }}
              variant="rounded"
              width="64%"
            />
          </Stack>
        </Stack>
      </Stack>
      <Divider
        sx={{
          marginBottom: rem(12),
          marginTop: 'auto',
        }}
      />
      <Box sx={{ padding: rem(12), paddingTop: 0 }}>
        <Stack>
          {showPreChatSkeleton && (
            <Stack
              gap={1.5}
              sx={{
                backgroundColor: theme.palette.common.white,
                border: `${rem(1)} solid ${theme.palette.divider}`,
                borderBottom: 0,
                borderTopLeftRadius: rem(12),
                borderTopRightRadius: rem(12),
                padding: rem(12),
                paddingBottom: rem(8),
              }}
            >
              <Skeleton
                animation="wave"
                height={rem(40)}
                sx={{ borderRadius: rem(8) }}
                variant="rounded"
              />
              <Skeleton
                animation="wave"
                height={rem(40)}
                sx={{ borderRadius: rem(8) }}
                variant="rounded"
              />
            </Stack>
          )}
          <Stack
            direction="row"
            alignItems="center"
            sx={{
              backgroundColor: theme.palette.common.white,
              border: `${rem(1)} solid ${theme.palette.divider}`,
              borderRadius: showPreChatSkeleton ? rem(12) : rem(48),
              ...(showPreChatSkeleton
                ? {
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                  }
                : {}),
              height: rem(48),
              paddingLeft: rem(16),
              paddingRight: rem(8),
            }}
          >
            <Skeleton
              animation="wave"
              height={rem(12)}
              sx={{ borderRadius: rem(6), flex: 1 }}
              variant="rounded"
            />
            <Skeleton
              animation="wave"
              height={rem(32)}
              variant="circular"
              width={rem(32)}
            />
          </Stack>
        </Stack>
      </Box>
    </Stack>
  )
}

export default ChatDialogLoadingSkeleton
